export const userIdentifier = "user#"
export const profileIdentifier = "profile#"
export const profilesDonwloadMsIdentifier = "downloadHighWaterMark#"
export const associationSettingsIdentifier = "associationSettings#"
export const docValidityCacheIdentifier = "docValidityCache#"
export const lastSelectedAssocationIdentifier = "lastSelectedAssociation#"
export const lastSelectedCohortIdentifier = "lastSelectedCohort#"
export const lastSelectedEmploymentStatusIdentifier = "lastSelectedEmploymentStatusIdentifier#"
export const highWaterMarkIdentifier = "hwm"
export const masterSettingsIdentifier = "masterSettings"
